angular.module('gym.payers').factory('EzidebitPayers', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('ezidebit_payers');
}]);
